import React from "react";
import { PanelType } from "@fluentui/react";
import CustomPanel from "../../../../SharedComponents/CustomPanel/CustomPanel";
import { CustomContactList } from "../../../../SharedComponents/CustomContactList";
import { IResult } from "../../../../SharedComponents/Interfaces/CustomContact.interfaces";

export interface CatalystContactsPanelProps {
  isOpen: boolean;
  onDismiss: () => void;
  customerName: string;
  contactData: IResult;
}

export const CatalystContactsPanel: React.FC<CatalystContactsPanelProps> = ({
  isOpen,
  onDismiss,
  customerName,
  contactData,
}) => {
  return (
    <CustomPanel
      enablePanel={isOpen}
      dismissPanel={onDismiss}
      panelTitle={`Contacts- ${customerName}`}
      panelType={PanelType.custom}
      isLoading={false}
      customWidth="500px"
    >
      <div style={{ marginTop: "20px" }}>
        <CustomContactList
          selectedKey="cxeContacts"
          contactData={contactData}
        />
      </div>
    </CustomPanel>
  );
};
